import type * as DashboardTypes from '@/modules/dashboard/dashboardTypes';
import type * as SearchTypes from '@/modules/search/searchTypes';

import service, { HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export const getSearches = (): Promise<
	HttpResponseSuccess<Array<SearchTypes.Search>>
> => apiService.get('/api/searches/get');

export const addSearch = (
	name: string,
	location: SearchTypes.SearchLocation,
	listId: string,
	params: DashboardTypes.Search[],
	filters: Record<string, boolean | number | undefined>
) =>
	apiService.post('/api/searches/add', {
		name,
		location,
		listId,
		params,
		filters
	});

export type SaveFilterParams = {
	name: string;
	location: SearchTypes.SearchLocation;
	listId: string;
	params: DashboardTypes.Search[];
	filters: DashboardTypes.BusinessQuery;
};
export const saveFilter = ({
	name,
	location,
	listId,
	params,
	filters
}: SaveFilterParams) =>
	apiService.post('/api/searches/add', {
		name,
		location,
		listId,
		params,
		filters
	});

export const editSearch = (searchId: string, name: string) =>
	apiService.put('/api/searches/edit', { searchId, name });

export const removeSearch = (searchId: string) =>
	apiService.delete('/api/searches/remove', { params: { searchId } });
